import { util as fabricNativeUtils, Point as FabricPoint } from 'fabric';

import { Coords, MediaElement, MediaLine } from 'editor/src/store/design/types';

import { CanvasRotation } from 'editor/src/component/EditorArea/types';

import { ObjectRect } from './Image/types';

function getElementRect(
  elementData: Exclude<MediaElement, MediaLine>,
  offset: Coords,
  canvasRotation: CanvasRotation,
  mm2px: (n: number) => number,
): ObjectRect {
  const offsetX = 0;
  const offsetY = 0;

  const coords = fabricNativeUtils.rotatePoint(
    new FabricPoint(offset.left + mm2px(elementData.x), offset.top + mm2px(elementData.y)),
    canvasRotation.canvasCenter,
    canvasRotation.angleRad,
  );
  const angle = elementData.r + canvasRotation.angleDeg;

  return {
    left: coords.x + offsetX,
    top: coords.y + offsetY,
    width: mm2px(elementData.width),
    height: mm2px(elementData.height),
    angle,
  };
}

export default getElementRect;
